export default class Bridge {
  static sayHello() {
    document.body.innerHTML = '<h1>Hello!</h1>';
  }
}
